import _defineProperty from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
var _name$components$crea;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moduleConfig from "../moduleConfig";
import request from "@/utils/request";
import { listToTree } from "@/utils/universal";
function getTree(data, url, method) {
  return request({
    url: url,
    method: method,
    data: data
  });
}

// parentDefaultVal 父级最高级默认Id是多少
// childrenId 当前选择的最后一级
// ProductLineList 总数据
// keyField 当前对象的id代码名称 默认等于Id
// parentField 当前对象的parentId名称 默认等于ParentId
function getParentId(childrenId, ProductLineList) {
  var keyField = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
  var parentField = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'parentId';
  var parentDefaultVal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "0";
  // var childrenId == childrenId;
  var dataArr = [];
  dataArr.push(childrenId);
  function oper() {
    for (var i = 0; i < ProductLineList.length; i++) {
      var parents = ProductLineList[i];
      if (parents[keyField] === childrenId) {
        if (dataArr.indexOf(1) !== -1) {
          break;
        } else {
          if (parents[parentField] !== parentDefaultVal) {
            dataArr.unshift(parents[parentField]);
            childrenId = parents[parentField];
            console.log(childrenId > 1);
            if (childrenId !== parentDefaultVal) {
              oper(childrenId);
            }
          }
        }
      }
    }
  }
  oper();
  return dataArr;
}
// childrenId当前选中的id
// ProductLineList总数据
function getFullCategroyName(childrenId, ProductLineList) {
  console.log("childrenId", childrenId);
  var selectIds = getParentId(childrenId, ProductLineList);
  console.log("selectIds", selectIds);
  var fullCategroyName = [];
  for (var i = 0; i < ProductLineList.length; i++) {
    var index = selectIds.indexOf(ProductLineList[i].id);
    if (index > -1) {
      fullCategroyName.push(ProductLineList[i]);
      selectIds.splice(index, 1);
    }
    if (selectIds.length <= 0) {
      break;
    }
  }
  return fullCategroyName;
}
console.log('🔵 OpCascader 文件被加载！');
export default (_name$components$crea = {
  name: "OpCascader",
  components: {},
  created: function created() {
    console.log('🔵 OpCascader 实例被创建！', this.componentId);
  },
  props: {
    paramsData: {
      // 接口的参数
      type: Object,
      default: function _default() {
        return {};
      }
    },
    method: {
      type: String,
      required: false,
      default: "get"
    },
    api: {
      type: String,
      required: false,
      default: ""
    },
    value: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    placeholder: {
      type: String,
      required: false,
      default: "请选择"
    },
    title: {
      type: String,
      required: false,
      default: ""
    },
    size: {
      type: String,
      required: false,
      default: "mini"
    },
    componentId: {
      type: Number,
      required: false,
      default: 1
    },
    showAllLevels: {
      type: Boolean,
      required: false,
      default: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    props: {
      type: Object,
      default: function _default() {
        return {
          multiple: false,
          // 多选
          checkStrictly: true,
          // 单选
          expandTrigger: 'click ',
          lazy: false,
          label: 'name',
          value: 'id',
          children: 'children'
        };
      }
    }
  },
  data: function data() {
    return {
      insValue: this.value,
      moduleConfig: moduleConfig,
      options: []
    };
  },
  computed: {},
  watch: {
    value: function value() {
      if (Array.isArray(this.value)) {
        this.insValue = this.value.map(function (item) {
          return JSON.parse(item).value;
        });
      } else {
        this.insValue = this.value.value;
      }
    }
  }
}, _defineProperty(_name$components$crea, "created", function created() {
  this.getData(this.paramsData);
}), _defineProperty(_name$components$crea, "methods", {
  change: function change(val) {
    var _this = this;
    // console.log(flatTree(this.options, 'childList'), '扁平化树')
    function flatTree(data) {
      var res = [];
      function fn(source) {
        source.forEach(function (el) {
          res.push(el);
          if (el.children && el.children.length > 0) {
            fn(el.children);
          }
        });
      }
      fn(data);
      return res;
    }
    console.log(flatTree(this.options), 999);
    console.log(this.insValue, 777);
    console.log(getFullCategroyName(this.insValue[this.insValue.length - 1], flatTree(this.options)), 135);
    var selectItems = [];
    if (Array.isArray(this.insValue[0])) {
      // 多选，多选操作数据返回还没写好
      this.insValue.forEach(function (item) {
        selectItems.push(getFullCategroyName(item[item.length - 1], flatTree(_this.options)));
        console.log(selectItems, 639);
      });
    } else {
      selectItems = getFullCategroyName(this.insValue[this.insValue.length - 1], flatTree(this.options));
    }
    var items = [];
    selectItems.forEach(function (item) {
      items.push(JSON.stringify({
        label: item.name,
        value: item.id
      }));
    });
    this.$emit("input", items);
    this.$emit("change", items);
  },
  getData: function () {
    var _getData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(data) {
      var result;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!this.api) {
              _context.next = 10;
              break;
            }
            if (!localStorage.getItem(this.api)) {
              _context.next = 5;
              break;
            }
            this.options = JSON.parse(localStorage.getItem(this.api));
            _context.next = 10;
            break;
          case 5:
            _context.next = 7;
            return getTree(data, this.api, this.method);
          case 7:
            result = _context.sent;
            // this.options = result.data
            this.options = listToTree(result.data, "0", "id", "parentId", "children");
            localStorage.setItem(this.api, JSON.stringify(this.options));
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function getData(_x) {
      return _getData.apply(this, arguments);
    }
    return getData;
  }()
}), _name$components$crea);